import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const TableDownstreamDashboardsFilteredByColumnQueryGql: DocumentNode = gql`
query TableDownstreamDashboardsFilteredByColumnQuery($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowDataFragment
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
